import { modifyAbnSearchValue } from "../helpers";
import config from "../../../../config";

export const addOrganisation = data =>
  fetch(`${config.ApiUrl.Rest}/organisations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const getOrganisations = (
  count_only = "",
  search = "",
  archived = "",
  field,
  direction,
  page = 0,
  page_size = 10
) => {
  return fetch(
    `${config.ApiUrl.Rest}/organisations?${count_only &&
      "count_only=y"}${search &&
      "&" + modifyAbnSearchValue(search)}${(archived && "&status=all") ||
      ""}${(field && "&order_by=" + field) || ""}${(direction &&
      "&order_dir=" + direction) ||
      ""}&page=${page}&page_size=${page_size}`,
    {
      mode: "cors",
      credentials: "include"
    }
  );
};

export const getDashboardClients = () => {
  return fetch(`${config.ApiUrl.Rest}/organisations?count_only=y`, {
    mode: "cors",
    credentials: "include"
  });
};

export const getSimpleOrganisations = (query = "") =>
  fetch(`${config.ApiUrl.Rest}/organisations/simple?${query || ""}`, {
    mode: "cors",
    credentials: "include"
  });

export const getOrganisationById = organisation_id =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}`, {
    mode: "cors",
    credentials: "include"
  });

export const modifyOrganisation = (data, organisation_id) =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const archiveOrganisation = id =>
  fetch(`${config.ApiUrl.Rest}/organisations/${id}`, {
    method: "DELETE",
    mode: "cors",
    credentials: "include"
  });

export const getOrganisationContacts = (
  organisation_id,
  archived = "",
  field,
  direction
) =>
  fetch(
    `${
      config.ApiUrl.Rest
    }/organisations/${organisation_id}/contacts?${(archived && "&status=all") ||
      ""}${(field && "&order_by=" + field) || ""}${(direction &&
      "&order_dir=" + direction) ||
      ""}`,
    {
      mode: "cors",
      credentials: "include"
    }
  );

export const getOrganisationUsers = organisation_id =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}/users`, {
    mode: "cors",
    credentials: "include"
  });

export const linkUsers = (data, organisation_id) =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}/users`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const unlinkUsers = (data, organisation_id) =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}/users`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const abnLookup = abn => {
  return fetch(
    `${config.ApiUrl.Rest}/public/abn-lookup?search_only=true&abn=${abn}`,
    {
      mode: "cors",
      credentials: "include"
    }
  );
};

export const getOrganisationsListAutocomplete = (
  page_size = 80,
  autocompleteField,
  autocompleteText = "",
  field,
  direction,
  search,
  archived,
  tenant_id
) =>
  fetch(
    `${config.ApiUrl.Rest}/organisations?&page_size=${page_size}${(archived &&
      "&status=all") ||
      ""}${(autocompleteField &&
      "&distinct=" +
        autocompleteField +
        "&" +
        autocompleteField +
        "=_like(" +
        modifyAbnSearchValue(autocompleteText) +
        ")_") ||
      ""}${(field && "&order_by=" + field) || ""}${(direction &&
      "&order_dir=" + direction) ||
      ""}${search ? "&" + modifyAbnSearchValue(search) : ""}`,
    {
      mode: "cors",
      credentials: "include"
    }
  );

export const lintContactsToOrganisations = (org_id, data) =>
  fetch(`${config.ApiUrl.Rest}/organisations/${org_id}/contacts`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const getOrganisationsAmount = (search = "", archived = "") => {
  return fetch(
    `${config.ApiUrl.Rest}/organisations?count_only=y${
      search ? "&" + modifyAbnSearchValue(search) : ""
    }${(archived && "&status=all") || ""}`,
    {
      mode: "cors",
      credentials: "include"
    }
  );
};

export const editOrganisationTags = (organisation_id, data) =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}/tags`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const deleteOrganisationTags = (organisation_id, data) =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}/tags`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include"
  });

export const getOrganisationTags = organisation_id =>
  fetch(`${config.ApiUrl.Rest}/organisations/${organisation_id}/tags`, {
    mode: "cors",
    credentials: "include"
  });

export const getOrgSubmissions = (search = "", field, direction, org_id) =>
  fetch(
    `${config.ApiUrl.Rest}/organisations/${org_id}/submissions?${search &&
      "&" + search}${(field && "&order_by=" + field) || ""}${(direction &&
      "&order_dir=" + direction) ||
      ""}`,
    {
      mode: "cors",
      credentials: "include"
    }
  );
